<template>
    <span v-if="appointment != null" class="c-client-names">
        <span v-for="client, i in appointment.clients" :key="client.id" class="c-client-names--item">
            <span v-if="client.ergosleep_id != null">
                <router-link :to="{name : 'client-detail', params : {ergosleep_id:client.ergosleep_id}}">{{formatClient(client)}}</router-link>
            </span>
            <span v-else>
                {{formatClient(client)}}
            </span>

            <span v-if="isStaff" class="staff">*{{$t("appointments.staff_label")}}*</span>

            <span v-if="client.additional_info.bedside" class="bedside">{{$t(`appointment_list.bedside_${client.additional_info.bedside}`)}}</span>

            <span class="c-client-names--and" v-if="i == 0 && appointment.clients.length == 2">&</span>
        </span>
    </span>
</template>

<script>
export default {
    name: "ClientNames",

    props: {
        appointment: {
            type: Object
        }
    },

    methods: {
        formatClient(client) {
            return client.firstname + " " + client.lastname;
        }
    },

    computed: {
        isStaff() {
            return this.appointment.clients.some(client => client.additional_info.is_staff);
        }
    }
};
</script>

<style lang="scss" scoped>
.c-client-names {

    line-height: normal;

    &--item {
        display: inline-block;
    }

    &--and {
        margin : 0 .35rem;
    }

    .staff {
        margin-left: 0.25rem;
        font-size: 0.9rem;
        text-transform: uppercase;
    }

    .bedside {
        width : 1.15rem;
        height : 1.15rem;
        border-radius: 50%;
        text-transform: uppercase;
        text-align: center;
        background: $color-green;
        color : white;
        font-size : .8em;
        padding: 0.2rem;
        display: inline-block;
        margin-left: 0.25rem;
    }
}
</style>